import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

const EthAddress = ({
  className = '',
  style = {}
}) => /*#__PURE__*/React.createElement("div", {
  className: className,
  style: style
}, /*#__PURE__*/React.createElement("span", {
  className: "tag"
}, /*#__PURE__*/React.createElement("strong", null, "Eth Address:"), " ", get(window, 'ethereum.selectedAddress', 'No Address Selected')));

export default EthAddress;
EthAddress.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};